module.exports = __webpack_public_path__ + "static/img/top-img-main-sm.177959e.jpg";